<template>
  <section>
    <div class="top-header-with-banner">
      <h2>{{ $t("FastTrack.ServiceReservation") }} {{ title }}</h2>
      <div class="content-current">
        <div
          class="under-banner"
          v-if="!loadingPage"
          style="text-align: center !important"
        >
          <loadingBar type="ripple" />
        </div>
        <div v-else>
          <div class="card-header">
            <h4>
              <!-- <i class="icon-user-1 beside-title-small"></i> -->
              {{ $t("HomeHeader.Search") }}
              <span style="color: #08446a; font-weight: 600">{{ title }}</span>             
            </h4>
      
          </div>
          <div class="content-current">
            <div>
              <div class="row">
                <div class="col-md-6 col-sm-6 col-lg-6">
                  <div>
                    <label>{{ $t("FastTrack.Servicetype") }}</label>
                    <div>
                      <select
                        @change="onChange($event)"
                        class="form-control"
                        required
                        v-model="selectedService"
                      >
                        <option value="" disabled>
                          {{ $t("FastTrack.SelectServiceType") }}
                        </option>
                        <option
                          v-for="item in services"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-sm-6 col-lg-6" v-if="providerId === 1">
                  <div class="form-group"    @click="checkLocale">
                    <label>{{ $t("FastTrack.Date") }} </label>

                    <!-- <date-picker  @change="selectDate" @select="selectDate" :column="1" mode="single"
                      v-model="selectdate" :from="fromDate" auto-submit locale="en" popover="bottom-right">
                    </date-picker> -->
       
                    <date-picker
                      input-format="YYYY/MM/DD"
                      display-format="jYYYY/jMM/jDD"
                      color="#00C3E1"
                      popover="bottom-right"
                      auto-submit                      
                      :locale="localee"
                      v-model="selectdate"
                      :from="fromDate"
                      :min="fiveAgo"
                   
                    />
                  </div>
                </div>

                <div class="col-md-6 col-sm-6 col-lg-6" v-if="providerId === 2">
                  <div class="form-group">
                    <label>  {{ $t("FastTrack.FlightDate") }} </label>
   
                    <date-picker
                      color="#00C3E1"
                      readonly
                      mode="single"
                      v-model="selectdate"
                      popover="bottom-right"
                      auto-submit
                      locale="en,fa"
                      input-format="YYYY/MM/DD"
                     :min="fiveAgo"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <pdk-qty
                    class="form-group"
                    style="padding-top: 20px"
                    :title="$t('FastTrack.Adult') "
                    :min="0"
                    :max="9"
                    controlType="tourism"
                    :default="adultCount"
                    @valueChange="onAdultsChange($event)"
                  />
                </div>
                <div class="col-md-12 col-sm-12" v-if="providerId === 2">
                  <pdk-qty
                    style="padding-top: 20px"
                    :title="$t('FastTrack.ChildrenUnder12')"
                    :min="1"
                    :max="9"
                    :default="childCount"
                    @valueChange="onChildrenChange($event)"
                  />
                </div>
                <div class="col-md-12 col-sm-12" v-else>
                  <pdk-qty
                    style="padding-top: 20px"
                    :title="$t('FastTrack.ChildrenUnder4')"
                    :min="1"
                    :max="9"
                    :default="childCount"
                    @valueChange="onChildrenChange($event)"
                  />
                </div>

                <div class="col-md-12 col-sm-12" v-if="providerId === 2">
                  <pdk-qty
                    style="padding-top: 20px"
                    :title="$t('FastTrack.ChildrenUnder2')"
                    :min="1"
                    :max="9"
                    :default="childCount"
                    @valueChange="onInfantChange($event)"
                  />
                </div>
                <div class="col-md-12 col-sm-12" v-else></div>

                <div class="col-12" style="text-align: center">
                  <button
                    class="btn btn-search"
                    type="button"
                    aria-expanded="false"
                    @click="search"
                    :disabled="$v.$invalid"
                    :class="{ disabledBtn: $v.$invalid }"
                  >
                    <span><i class="fa fa-search fa-fw"></i> {{ $t("HomeHeader.Search") }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <p>
                {{ $t("FastTrack.ServicesDescriptionTitle") }}:
                <span style="color: #008489; font-weight: 600">{{
                  serviceDescription
                }}</span>
              </p>
            </div>
          </div>
          <hr />
          <div class="content-current col-md-12">
            <div class="accordion-expand" @click="openRules">
              <h4
                :class="{ expanded: expandToggle }"
                @click="expandToggle = !expandToggle"
              >
                <i class="fa fa-list-alt"></i> {{ $t("FastTrack.ServicesDescriptionTitle2") }}
              </h4>
              <i class="icon-down-open-2"></i>
            </div>
            <transition name="slide-fade">
              <div class="fdesc-text" v-if="showRules">
                <p v-html="rules" ref="document"></p>
              </div>
            </transition>
          </div>
                <h4>
               <span>*  شماره تماس  24 ساعته دفتر لانژ فرودگاه: 02151007227</span>
            </h4>
        </div>
        <div id="bottomAnchor"></div>

        <div class="content-current" v-if="isLoading && !showResult">
          <div class="col-12 col-sm-12">
            <table>
              <thead>
                <tr>
                  <th class="top-tb" colspan="3">{{ $t("Name") }}</th>
                  <th class="top-tb" colspan="3">{{ $t("FastTrack.BasePrice") }}</th>
                  <th class="top-tb" colspan="2">{{ $t("FastTrack.ValueAdded") }}</th>
                  <th class="top-tb" colspan="2">{{ $t("FastTrack.BasePrice") }}</th>
                  <th class="top-tb" colspan="2"></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in tourismList">
                  <tr>
                    <td class="top-tb" colspan="3">
                      {{ item.product.name }}
                      <p>{{ item.schedule.description }}</p>
                    </td>
                    <td class="top-tb" colspan="3" style="font-weight: bold">
                      {{ item.itemRackPrice | numFormat | rial }}
                    </td>
                    <td class="top-tb" colspan="2" style="font-weight: bold">
                      {{ item.tax | numFormat | rial }}
                    </td>
                    <td class="top-tb" colspan="2" style="font-weight: bold">
                      <p
                        v-if="
                          parseInt(calcTotalAmount) != 0 &&
                          parseInt(calcTotalAmount) !=
                          parseInt(calcPayableAmount)
                        "
                        style="text-decoration: line-through;
                          color: #999;
                          margin: 0px;
                        "
                      >
                        {{ calcTotalAmount | numFormat | rial }}
                      </p>
                      {{ calcPayableAmount | numFormat | rial }}
                    </td>
                    <td class="top-tb" colspan="2">
                      <button
                        v-if="totalAmount > 0"
                        class="btn-cyan"
                        @click="reserve(item)"
                      >
                        {{ $t("Profile.Reserve") }}
                      </button>

                      <button v-else class="btn btn-primary btn-block" disabled>
                              {{ $t("Profile.Reserve") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="item.addOnOptionList.length > 0">
                    <td
                      colspan="12"
                      style="width: 80%;
                        padding: 0.1rem 2.05rem;
                        vertical-align: middle;
                      "
                    >
                      <h3 style="color: #008489">{{ $t("FastTrack.OtherServices") }}</h3>
                    </td>
                  </tr>
                  <tr v-if="item.addOnOptionList.length > 0">
                    <td
                      colspan="12"
                      style=" width: 100%;
                        vertical-align: middle;
                      "
                    >
                      <table id="addOnOption" class="base-tables">
                        <thead>
                          <tr colspan="12">
                            <th class="addon-tb" colspan="3">{{ $t("Name") }}</th>
                            <th class="addon-tb" colspan="3">{{ $t("FastTrack.BasePrice") }}</th>
                            <th class="addon-tb" colspan="3">{{ $t("FastTrack.ValueAdded") }}</th>
                            <th class="addon-tb qua-counts" colspan="1">
                              {{ $t("FastTrack.Count") }}
                            </th>
                            <th class="addon-tb addon-price" colspan>
                               {{ $t("FastTrack.TotalPrice") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="addon in item.addOnOptionList">
                            <tr class="addon-tb">
                              <td v-if="addon.name == 'چمدان'" class="addon-tb" colspan="3">
                                چمدان اضافه
                              </td>
                              <td v-else class="addon-tb" colspan="3">
                                {{ addon.name }}
                              </td>
                              <td class="addon-tb" colspan="3">
                                {{ addon.basePrice | numFormat | rial }}
                              </td>

                              <td class="addon-tb" colspan="3">
                                {{ addon.tax | numFormat | rial }}
                              </td>

                              <td class="addon-tb qua-counts" colspan="1">
                                <pdk-qty
                                  style=""
                                  :min="0"
                                  :max="9"
                                  controlType="tourism"
                                  @valueChange="addOnTb($event, addon)"
                                />
                                <!-- <input
                                  style="
                                    width: 100px !important;
                                    padding: 0em 0.2em;
                                  "
                                  type="number"
                                  v-model="addon.selectedCount"
                                  min="0"
                                /> -->
                              </td>
                              <td class="addon-tb addon-price" colspan>
                                {{
                                  (addon.itemPrice * addon.selectedCount)
                                    | numFormat
                                    | rial
                                }}
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else-if="emptyResult" class="content-current">
          <p class="empty-alert">
            <i class="icon-attention-1"></i>
            {{ $t("FastTrack.NoInformationForYourRequest") }}
          </p>
        </div>
        <div class="under-banner" style="text-align: center !important">
          <loadingBar type="ripple" v-if="showResult" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import datePicker, { PersianDate } from "@alireza-ab/vue-persian-datepicker";
import store from "../../views/tourism/store/index";
import momentjalaali from "moment-jalaali";
import moment from "moment";
import PdkQty from "../PdkQty";
import date from "../../utils/date";
import loadingBar from "../../components/loading/pdkLoadingBar";
import { required } from "vuelidate/lib/validators";

export default {
  name: "FastTrackingSearch",
  store: store,
  components: {
    PdkQty,
    loadingBar,
  },
  data() {
    return {
      loadingPage: false,
      isLoading: false,
      emptyResult:false,
      title: "",
      selectedService: "",
      childCount: 0,
      adultCount: 1,
      infantCount: 0,
      // selectdate: new Date().setDate(new Date().getDate()),
      selectdate: "",
      services: [],
      tourismList: [],
      showRules: false,
      today: moment().format('jYYYY/jMM/jDD'),
      fiveAgo:moment().add(-7, 'day').format('jYYYY/jMM/jDD'),
      expandToggle: false,
      rules: "",
      localee:"fa",
      providerId: 0,
      providerName: "fasttrack",
      provider: {},
      serviceDescription: "",
      opened: [],
      totalAmount: 0,
      fromDate: momentjalaali(new Date()).format("jYYYY/jMM/jDD"),
      fromFastTrack: moment(new Date()).format("YYYY-MM-DD"),
      showResult: false,
    };
  },
  validations() {
    return {
      selectdate: { required },
      selectedService: { required },
    };
  },
  computed: {
    calcPayableAmount() {
      let basePrice = 0;
      let totalPrice = this.tourismList.map(function (item) {
        item.addOnOptionList.forEach((element) => {
          if (element.selectedCount != "")
            basePrice +=
              parseInt(element.itemPrice) * parseInt(element.selectedCount);
        });

        return item.totalPrice + basePrice;
      });
      this.totalAmount = totalPrice;
      return totalPrice;
    },
    calcTotalAmount() {
      let basePrice = 0;
      let totalPrice = this.tourismList.map(function (item) {
        item.addOnOptionList.forEach((element) => {
          if (element.selectedCount != "")
            basePrice +=
              parseInt(element.itemPrice) * parseInt(element.selectedCount);
        });

        return item.totalBasePrice + basePrice;
      });
      return totalPrice;
    },
  },
  created() {
    this.clearStors(); 
    this.providerName = this.$route.params.providerName;

    if (this.providerName.toLowerCase() === "fasttrack") this.providerId = 2;
    else if (this.providerName.toLowerCase() === "dolphin") this.providerId = 1;

    this.getProductServices();
  },
  methods: {
    clearStors() {
      this.$store.dispatch("storeCustomerInfo", "");
      this.$store.dispatch("storeBookingData", "");
      this.$store.dispatch("storeSelectedReserve", "");
      this.$store.dispatch("storeGuestsInfo", "");
    },
    checkLocale(){
                  debugger
        this.localee = this.$i18n.locale ;
    },
      // selectDate(date) {
    //   let p = new PersianDate();

    //   this.selectdate = p
    //     .parse(date.d.year, date.d.month, date.d.date)
    //     .toString();
    // },
    convertDate(date) {
      if (momentjalaali(date, "jYYYY/jMM/jDD").isValid())
        return momentjalaali(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");
    },
    onChildrenChange: function (val) {
      this.childCount = val;
    },
    onAdultsChange: function (val) {
      this.adultCount = val;
    },
    addOnTb: function (val, addon) {
      addon.selectedCount = val;
    },
    onInfantChange: function (val) {
      this.infantCount = val;
    },
    isPersianLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0600-\u06FF\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    async getProductServices() {
      this.loadingPage = false;

      if (parseInt(this.providerId) === 2) {
        debugger
        const res = await this.$store.dispatch(
          "getProductServices",
          this.providerId
        );
        this.services = res.data;
      } else {
        const res = await this.$store.dispatch(
          "getProductServicesDolphin",
          this.providerId
        );
        this.services = res.data;
      }

      // this.selectedService = this.services[0].id;
      this.title = this.services[0].provider.description;
      this.provider = this.services[0].provider;
      this.serviceDescription = this.services[0].description;
      this.loadingPage = true;
    },
    onChange(val) {
      const data = this.services.find((p) => p.id == val.target.value);
      this.serviceDescription = data.description;
      this.rules = data.termsAndConditions;
    },
    search() {
      this.showResult = true;
      debugger
      const data = {
        reserveDate: date.ConvertToGregorian(this.selectdate),
        productId: this.selectedService,
        // sourceId: localStorage.getItem("SourceIdInReport"),
        sourceId: localStorage.getItem("SourceIdInReport"),
        guestCount: parseInt(this.adultCount) + parseInt(this.childCount),
        adultCount: this.adultCount,
        childCount: this.childCount,
        infantCount: this.infantCount,
        isAdmin: false,
        isReception: false,
      };

      if (parseInt(this.providerId) === 2) {
        this.$store.dispatch("checkAvailability", data).then((res) => {
          let response = res;
          if(response.data.data.length == 0){
                this.emptyResult = true;
              }
          if (response != undefined)
            if (response.status == 200) {
              this.isLoading = true;
              this.tourismList = response.data.data;
              if (this.tourismList.length)
                this.rules = this.tourismList[0].product.termsAndConditions;
              else this.isLoading = false;
              this.showResult = false;
            }
          
        });
      } else {
        this.$store.dispatch("checkAvailabilityDolphin", data).then((res) => {
          let response = res;
          if(response.data.data.length == 0){
                this.emptyResult = true;
              }
          if (response != undefined)
            if (response.status == 200) {
              this.isLoading = true;
              this.tourismList = response.data.data;
              if (this.tourismList.length)
                this.rules = this.tourismList[0].product.termsAndConditions;
              else this.isLoading = false;

              this.showResult = false;
            }
  
        });
      }
      this.$nextTick(() =>
        document
          .getElementById("bottomAnchor")
          .scrollIntoView({ behavior: "smooth" })
      );
    },
    reserve(item) {
      const addOnOption = [];
      item.addOnOptionList.forEach((element) => {
        if (element.selectedCount != "")
          if (parseInt(element.selectedCount) > 0) {
            const totalPrice =
              parseInt(element.selectedCount) * element.itemPrice;
            element.totalPrice = totalPrice;

            const totalBasePrice =
              parseInt(element.selectedCount) * element.itemPrice;
            element.totalBasePrice = totalBasePrice;

            addOnOption.push(element);
          }
      });
      const data = {
        totalAmount: this.totalAmount,
        addOnOptionList: addOnOption,
        serviceName: item.product.name,
        scheduleDescription: item.schedule.description,
        totalPrice: item.totalPrice,
        fromDate: item.fromDate,
        toDate: item.toDate,
        scheduleTime: item.schedule.description,
        scheduleId: item.scheduleId,
        productId: item.productId,
        guestCount:
          parseInt(item.adultCount) +
          parseInt(item.childCount) +
          parseInt(item.infantCount),
        adultCount: item.adultCount,
        childCount: item.childCount,
        infantCount: item.infantCount,
        provider: this.provider,
        rules: item.product.termsAndConditions,
      };

      this.$store.dispatch("storeSelectedReserve", data);
      this.$router.push({
        path: "/tourism/tourismBook/" + this.providerName,
      });
    },
    openRules() {

      this.showRules = !this.showRules;
    },
  },
};
</script>


<style scoped>
.top-header-with-banner {
  background-image: url("/img/fasadfa1321_dariushgroup.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 10% 11% 5px;
}

.top-header-with-banner h2 {
  text-align: center;
  margin: 40px;
}

.top-header-with-banner > .content-current {
  background-color: rgb(255 255 255 / 90%);
  box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
    100px 100px 80px rgba(0, 0, 0, 0.07);
  border-top: 1px solid #e9e9e9 !important;
  padding: 30px !important;
  margin-bottom: 200px;
}

.content-current {
  max-width: 1230px;
  margin: 0 auto;
  border: none !important;
  border-radius: 40px;
}

.content-current > .under-banner {
  padding: 30px 25px;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 8);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}

.btn-search {
  background-color: #fcbe2f !important;
  border-radius: 20px;
  height: 45px !important;
  font-size: 14px !important;
  width: 200px !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  color: rgb(95, 93, 93);
  font-weight: bold;
}

.btn-search:hover {
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
  transform: translateY(-1px);
}

.addon-tb {
  padding: 1em 0em;
  text-align: center;
}

.addon-title {
  padding: 1em 0em;
  text-align: center;
}

.top-tb {
  padding: 1em 0em;
  text-align: center;
  width: 20%;
}
.empty-alert{
  font-size: 18px;
  font-weight: 500;
  color: #ff5874;
  text-align: center;
  margin: 25px;
}
@media (max-width: 768.99px) {
  .content-current {
    padding: 5px !important;
  }

  .top-header-with-banner {
    background-image: url("/img/fasadfa1321mob_ca.jpg");
    padding: 10% 5% 5px;
  }

  .top-header-with-banner h2 {
    margin: 65px 40px 30px;
    font-size: 22px;
    font-weight: 700;
    color: #2561a4;
    text-shadow: 1px 0px 7px rgb(255 255 255 / 80%);
  }

  .pdp .pdp-picker.pdp-top {
    z-index: 9999999;
  }

  .btn-search {
    margin-bottom: 25px;
  }
}
#bottomAnchor{
  position: absolute;
      bottom: 45%;
      width: 100px;
}
.btn-cyan {
  padding: 6px 45px 11px;
  background: #14cee1;
  border-radius: 20px;
  color: #fff;
  font-size: 15px;
  font-weight: 300;
  border: none;
}

.base-tables th {
  background-color: #07294e;
  color: #ffffff;
}

.addon-tb[data-v-40377d4f] {
  text-align: center;
  border: 1px solid black;
}

table {
  width: 100%;
}

@media (max-width: 467px) {
  .btn-cyan {
    padding: 6px 10px 11px;
    color: #fff;
    font-size: 14px;
    border-radius: 11px;
  }

  .top-tb {
    font-size: 13px;
  }

  table {
    width: 110%;
    margin-right: -21px;
  }

  table .addon-tb {
    font-size: 13px;
  }
}
</style>